<div class="side-menu">
    <div class="content-center">
        <img src="../../../../assets/images/mati-name-icon.svg" alt="mati-name" width="95px" height="64px">
    </div>
    <div class="menu-item mt-56" [routerLink]="['/']"
    [routerLinkActive]="['active']" 
    [routerLinkActiveOptions]="{ exact: true }">
        <div class="img-circle">
            <img src="../../../../assets/images/admin-icon-1.svg" alt="admin-icon-1" class="img-1" width="24px" height="24px">
            <img src="../../../../assets/images/admin-icon-2.svg" alt="admin-icon-2" class="img-2" width="33px" height="33px">
            <img src="../../../../assets/images/admin-icon-3.svg" alt="admin-icon-3" class="img-3" width="33px" height="33px">
        </div>
        <div class="menu-title mt--4">
            Admin panel
        </div>
    </div>
    <div class="menu-item mt-40" [routerLink]="['/farm']"
    [routerLinkActive]="['active']">
        <div class="img-circle">
            <img src="../../../../assets/images/farm-icon-1.svg" alt="farm-icon-1" class="img-1" width="24px" height="24px">
            <img src="../../../../assets/images/farm-icon-2.svg" alt="farm-icon-2" class="img-2" width="33px" height="33px">
            <img src="../../../../assets/images/farm-icon-3.svg" alt="farm-icon-3" class="img-3" width="33px" height="33px">
        </div>
        <div class="menu-title mt--4">
            Farm app
        </div>
    </div>
    <div class="menu-item mt-40" [routerLink]="['/warehouse']"
    [routerLinkActive]="['active']">
        <div class="img-circle">
            <img src="../../../../assets/images/warehouse-icon-1.svg" alt="Warehouse-icon-1" class="img-1" width="24px" height="24px">
            <img src="../../../../assets/images/warehouse-icon-2.svg" alt="Warehouse-icon-2" class="img-2" width="33px" height="33px">
            <img src="../../../../assets/images/warehouse-icon-3.svg" alt="Warehouse-icon-3" class="img-3" width="33px" height="33px">
        </div>
        <div class="menu-title mt--4">
            Warehouse app
        </div>
    </div>
    <div class="menu-item mt-40" [routerLink]="['/labapp']"
    [routerLinkActive]="['active']">
        <div class="img-circle">
            <img src="../../../../assets/images/lab-app-icon-1.svg" alt="lab-app-icon-1" class="img-1" width="24px" height="24px">
            <img src="../../../../assets/images/lab-app-icon-2.svg" alt="lab-app-icon-2" class="img-2" width="33px" height="33px">
            <img src="../../../../assets/images/lab-app-icon-3.svg" alt="lab-app-icon-3" class="img-3" width="33px" height="33px">
        </div>
        <div class="menu-title mt--4">
            LAB app
        </div>
    </div>
    <div class="menu-item pull-bottom" data-toggle="modal" data-target="#switchModal" id="switchModalBtn" #switchModalBtn>
        <div class="base-name">
            {{currentBase.name}}
        </div>
        <hr style="border-top: 1px solid #FFF;margin: 0px;">
        <button type="button" class="switch-btn">
            <img src="../../../../assets/images/reload-2.svg" alt="reload-2" width="16px" height="16px" >
            Switch Base
        </button>
    </div>
</div>

  <!--switch Modal -->
  <div class="modal fade" id="switchModal" tabindex="-1" role="dialog" aria-labelledby="switchModal" aria-hidden="true"
  data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-sm" role="document">
      <div class="modal-content">
        <div class="switch-modal-header">
            <div class="header" id="exampleModalLabel">
                <img src="../../../../assets/images/reload-1.svg" alt="reload-1" width="24px"
                height="24px" >
                Switch Modal
            </div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" style="padding:0px;overflow-y: auto;">
            <div class="bases-tile" *ngFor="let base of baseAssigned"  data-dismiss="modal"
            (click)="onUpdateBase(base.baseId,base.baseName)">
                {{base.baseName}}
            </div>
        </div>
      </div>
    </div>
  </div>